<template>
	<div>
		<div :style="{backgroundColor:bg}" class="arrow-img" v-if="routePages<=1"></div> 
	</div>
</template>

<script>
	export default{
		props:{
			bg:{
				default:'white',
				type:String
			}
		},
		data(){
			return{
				routePages:0
			}
		},
		mounted() {
			this.routePages = this["$router"].options.routes.length;
			console.log('....路由'+this.routePages)
			console.log(this.$router)
		},
		activated() {
			this.routePages = this["$router"].options.routes.length;
			console.log('....路由'+this.routePages)
			console.log(this.$router)
		},
	}
</script>
<style scoped>
	.arrow-img {
		width: 30px;
		height: calc(44px + env(safe-area-inset-top));
		position: fixed;
		left: 0px;
		top: 0px;
		z-index: 999;
	}
</style>



// WEBPACK FOOTER //
// src/components/arrow-img.vue